export default __webpack_public_path__ + "static/media/858_7.e68c0d61.jpg";